import { defineStore } from "pinia";
import { ref } from "vue";

export const useRPCStore = defineStore("rpc", () => {
	// data
	const rpcURL = ref<string>("https://swift-mariele-fast-mainnet.helius-rpc.com/");

	return { rpcURL };
});
